// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__CtvmS","card":"Cards_card__LpWen","infected":"Cards_infected__-nWFe","recovered":"Cards_recovered__CO-4p","deaths":"Cards_deaths__k-qaC"};